import { definePreset } from '@primeuix/themes'
import Lara from '@primeuix/themes/lara'

export const PrenoThemePreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '#e6f2fc',
            100: '#b3d7f7',
            200: '#80bcf1',
            300: '#4da1ec',
            400: '#268ee8',
            500: '#007be4',
            600: '#006dcb',
            700: '#005aaa',
            800: '#004889',
            900: '#003568',
            950: '#002347',
        },
    },
    components: {
        dialog: {
            root: {
                borderColor: '#E5E5E5',
                background: '#fff',
            },
            content: {
                padding: '0',
            },
        },
        togglebutton: {
            root: {
                borderColor: '#424b4f',
                checkedColor: '#fff',
                checkedBorderColor: '#424b4f',
                checkedBackground: '#424b4f',
            },
        },
        button: {
            root: {
                label: {
                    fontWeight: 'normal',
                },
            },
        },
        checkbox: {
            root: {
                checkedBackground: '#424b4f',
                checkedBorderColor: '#424b4f',
                hoverBorderColor: '#424b4f',
                checkedHoverBackground: '#424b4f',
                checkedHoverBorderColor: '#fff',
            },
        },
        radiobutton: {
            root: {
                borderColor: '{primary.color}',
                background: '#fff',
                hoverBorderColor: '{primary.color}',
                checkedBorderColor: '{primary.color}',
                checkedBackground: '#fff',
                checkedHoverBackground: '#fff',
                checkedHoverBorderColor: '{primary.color}',
            },
            icon: {
                checkedColor: '{primary.color}',
                checkedHoverColor: '{primary.color}',
            },
        },
        datatable: {
            colorScheme: {
                light: {
                    headerCell: {
                        background: 'transparent',
                    },
                },
            },
        },
    },
})
